import BookingItemCheckBox from './BookingItemCheckBox';

export default BookingItemCheckBox;
